$(document).ready(async function () {
    
    crypto.subtle.digest(
        "SHA-256",
        new TextEncoder().encode(window.location.hostname)
    ).then(async hash => {

        const keyPoint = [...new Uint8Array(hash)]
            .map(b => b.toString(16).padStart(2, "0"))
            .join("");

        if (keyPoint === "9c17c0e275726476209093b3830b5cbe63279d301e783281ab420b32869996ee") {
            refreshCart(true);

            if (window.location.pathname === "/cart") {
                window.location.href = "/?cart=open";
                return;
            }
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('cart') && urlParams.get('cart') === 'open') {
                openCart();
            }

            const protectionProductId = 9393063756015;

            try {

                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();

                const updates = {};

                cart.items.forEach(function(item) {

                    if (item.product_id == protectionProductId) {
                        updates[item.key] = 0;
                    }

                });
                if (Object.keys(updates).length > 0) {

                    await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: updates
                        })
                    });
                    window.location.reload();
                }

            } catch (error) {
                console.error('Failed to remove protection items:', error);
            }
        }

    });
});

// open cart on navigation
$('.header .icon-cart').on('click', function(e) {
    e.preventDefault();
    openCart();
});

function openCart() {
    $('.header .nav-toggle i').removeClass('fa-xmark').addClass('fa-bars');
    $('.nav-mobile').removeClass('open');

    $('#popup-cart').css('display', 'flex').hide().fadeIn();
    $('.cart').addClass('open');

    ScrollLock.lock();
}

// close cart
$(document).on('click', '#popup-cart .cart-close', function(e) {
    e.preventDefault();
    closeCart();
});

function closeCart() {
    $('#popup-cart').fadeOut();
    $('.cart').removeClass('open');

    ScrollLock.unlock();
}

// form add to cart
$('.atc-form').on('submit', function (event) {
    event.preventDefault();

    const $checkbox = $('[name="properties[__shopify_send_gift_card_to_recipient]"]');
    const $email = $('[name="properties[Recipient email]"]');

    const isGiftChecked =
        $checkbox.length &&
        $checkbox.is(':visible') &&
        $checkbox.is(':checked');

    const emailValue = $email.length ? $.trim($email.val()) : '';
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);

    const emailInvalid = !emailValue || !isValidEmail;

    if (isGiftChecked && emailInvalid) {
        $('.giftcard-error').show();
        return;
    }

    $('.giftcard-error').hide();

    let productId = $(this).find('[name="product-id"]').val();
    let formData = $(this).serialize();

    $('.btn-atc').attr('disabled', true);
    $('.btn-atc span').css('visibility', 'hidden');
    $('.btn-atc .atc-overlay').css('display', 'flex');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            openCart();

            $('.btn-atc').attr('disabled', false);
            $('.btn-atc span').css('visibility', 'visible');
            $('.btn-atc .atc-overlay').css('display', 'none');

        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});

// item remove to cart
$(document).on('click', '.product-remove', function(event) {
    event.preventDefault();

    $(this).parents('.product-cart').remove();
    getSubtotal();

    $('#popup-cart .cart-checkout a').addClass('disabled');
    $('#popup-cart .cart-checkout a span').css('visibility', 'hidden');
    $('#popup-cart .cart-checkout a .atc-overlay').css('display', 'flex');

    let removeUrl = $(this).attr('href'); 
    $.ajax({
        type: 'POST',
        url: removeUrl,
        success: function() {
            if ($('.product-cart').length != 0) {
                console.log($('#popup-cart .with-shipping-protection form [name="id"]').length);
                if ($('#popup-cart .with-shipping-protection form [name="id"]').length > 0) {
                    updateProtectionPrice();
                }
                else {
                    $('#popup-cart .with-shipping-protection').remove();
                    $('#popup-cart .cart-checkout a').removeClass('disabled');
                    $('#popup-cart .cart-checkout a span').css('visibility', 'visible').html('Checkout');
                    $('#popup-cart .cart-checkout a .atc-overlay').css('display', 'none');
                }
            }
            else {
                $('#popup-cart .with-shipping-protection').remove();
                $('#popup-cart .cart-checkout a span').css('visibility', 'visible').html('Checkout');
                $('#popup-cart .cart-checkout a .atc-overlay').css('display', 'none');
            }
        },
        error: function(xhr, status, error) {
            console.error('Error removing item:', error);
        }
    });
});

// update quantity
var qtyTimer;
function updateQty(updateUrl) {
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function() {
        $.ajax({
            type: 'POST',
            url: updateUrl,
            success: function() {
                if ($('#popup-cart .with-shipping-protection').length)
                    updateProtectionPrice();
                else {
                    $('#popup-cart .cart-checkout a').removeClass('disabled');
                    $('#popup-cart .cart-checkout a span').css('visibility', 'visible');
                    $('#popup-cart .cart-checkout a .atc-overlay').css('display', 'none');
                }
            },
            error: function(xhr, status, error) {
                console.error('Error updating item:', error);
            }
        });
    }, 300);
}

$(document).on('click', '#popup-cart .less_qty, .main-cart .less_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    if (qty > 1) {
        qty--;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;

        $(`#popup-cart .qty[data-key="${key}"]`).val(qty);

        updateQty(updateUrl);

        let line = $(`.product-cart[data-key="${key}"]`);
        let itemPrice = line.data('item-price') * qty;
        let itemComparePrice = line.data('item-compare-price') * qty;
        
        line.find('.product-price .final').html(Shopify.formatMoney(itemPrice));
        line.find('.product-price .original').html(Shopify.formatMoney(itemComparePrice));

        getSubtotal();
        $('#popup-cart .cart-checkout a').addClass('disabled');
        $('#popup-cart .cart-checkout a span').css('visibility', 'hidden');
        $('#popup-cart .cart-checkout a .atc-overlay').css('display', 'flex');
    }
});
$(document).on('click', '#popup-cart .add_qty, .main-cart .add_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    qty++;

    let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;
    
    $(`#popup-cart .qty[data-key="${key}"]`).val(qty);

    updateQty(updateUrl);

    let line = $(`.product-cart[data-key="${key}"]`);
    let itemPrice = line.data('item-price') * qty;
    let itemComparePrice = line.data('item-compare-price') * qty;
    
    line.find('.product-price .final').html(Shopify.formatMoney(itemPrice));
    line.find('.product-price .original').html(Shopify.formatMoney(itemComparePrice));

    getSubtotal();
    $('#popup-cart .cart-checkout a').addClass('disabled');
    $('#popup-cart .cart-checkout a span').css('visibility', 'hidden');
    $('#popup-cart .cart-checkout a .atc-overlay').css('display', 'flex');
});

// refresh cart
function refreshCart(isPageLoad = false) {
    
    $('#popup-cart .el-overlay').show();

    $.ajax({
        type: 'GET',
        url: window.location.href,
        dataType: 'html',
        success: function(cartHtml) {
            let newCart = $(cartHtml).find('#popup-cart .cart').html();
            $('#popup-cart .cart').html(newCart);

            let newCartCheckout = $(cartHtml).find('#popup-cart .cart-checkout').html();
            $('#popup-cart .cart-checkout').html(newCartCheckout);

            getSubtotal();

            $('#popup-cart .el-overlay').hide();
        },
        error: function(xhr, status, error) {
            console.error('Error fetching cart data:', error);
            $('#popup-cart .el-overlay').hide();
        }
    });
}

// close if away
$('#popup-cart .overlay').on('click', function () {
    closeCart();
});

$(document).on('click', '#popup-cart .cart-checkout a:not(.checkout-shipping-protection)', function(e) {
    e.preventDefault();
    
    let note = $(document).find('[name="order-note"]').val();

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            note: note
        }),
    })
    .then(response => {
        if (response.ok) {
            window.location.href = '/checkout';
        }
    })
    .catch(error => {
        console.error('Error updating cart note:', error);
    });
});

function getSubtotal() {
    let total = 0;
    let totalCompare = 0;
    let totalQty = 0;

    $('.product-cart').each(function () {
        const price = parseFloat($(this).attr('data-item-price')) || 0;
        const comparePrice = parseFloat($(this).attr('data-item-compare-price')) || 0;
        const qty = parseInt($(this).find('.quantity__input').val()) || 0;

        total += price * qty;
        totalCompare += comparePrice * qty;
        totalQty += qty;
    });

    $('.cart-total-price span:not(.cart-total-less)').html(Shopify.formatMoney(total));

    if (totalCompare !== 0)
        $('.cart-total-price span.cart-total-less').html(Shopify.formatMoney(totalCompare));
    else
        $('.cart-total-price span.cart-total-less').html('');

    let displayDot = totalQty > 9 ? '9+' : totalQty;
    $('.header .icon-cart .dot').html(displayDot);

    if (totalQty == 0) {
        $('.cart-body').html(`
            <div class="d-flex align-items-center justify-content-center h-100">
                <p class="subheading f-secondary">
                    There's no item in your cart.
                </p>
            </div> 
        `);

        $('#popup-cart .cart-checkout a').addClass('disabled');
        document.querySelectorAll('.header .icon-cart .dot')
        .forEach(el => {
            el.style.setProperty('display', 'none', 'important');
        });
    }
    else {
        $('#popup-cart .cart-checkout a').removeClass('disabled');
        $('.header .icon-cart .dot').css('display', 'flex');
    }
}

let isUpdatingProtectionPrice = false;
function updateProtectionPrice() {
    if (isUpdatingProtectionPrice) return;

    if ($('#popup-cart .with-shipping-protection').length) {
        isUpdatingProtectionPrice = true;
        $.ajax({
            type: 'GET',
            url: window.location.href,
            dataType: 'html',
            success: function(cartHtml) {
                let newPrice = $(cartHtml)
                    .find('#popup-cart .with-shipping-protection')
                    .html();

                $('#popup-cart .with-shipping-protection').html(newPrice);
            },
            error: function(xhr, status, error) {
                console.error('Error updating shipping protection price:', error);
            },
            complete: function() {
                $('#popup-cart .cart-checkout a').removeClass('disabled');
                $('#popup-cart .cart-checkout a span').css('visibility', 'visible');
                $('#popup-cart .cart-checkout a .atc-overlay').css('display', 'none');
                isUpdatingProtectionPrice = false;

                if ($('#popup-cart .with-shipping-protection form [name="id"]').length < 1)
                    $('#popup-cart .cart-checkout a span').css('visibility', 'visible').html('Checkout');
            }
        });
    }
}

$(document).on('click', '.checkout-shipping-protection', async function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const items = [];

    $('.with-shipping-protection form').each(function() {
        const id = $(this).find('[name="id"]').val();
        const quantity = $(this).find('[name="quantity"]').val() || 1;

        if (id) {
            items.push({
                id: Number(id),
                quantity: Number(quantity)
            });
        }
    });

    if (items.length) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items: items })
        });
    }

    window.location.href = '/checkout';
});